import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';

interface CallToActionProps {
  title: string;
  description: string;
  buttonText: string;
  buttonLink: string;
  showCallButton?: boolean;
  bgColor?: string;
}

const CallToAction: React.FC<CallToActionProps> = ({
  title,
  description,
  buttonText,
  buttonLink,
  showCallButton = true,
  bgColor = 'bg-primary-600',
}) => {
  return (
    <section className={`${bgColor} py-16`}>
      <div className="container-custom">
        <div className="flex flex-col md:flex-row md:items-center justify-between">
          <div className="mb-8 md:mb-0 md:mr-8">
            <h2 className="text-3xl font-bold text-white mb-4">
              {title}
            </h2>
            <p className="text-white/90 text-lg max-w-2xl">
              {description}
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <Link 
              to={buttonLink} 
              className="btn bg-white text-primary-700 hover:bg-gray-100 font-semibold text-center"
            >
              {buttonText}
            </Link>
            
            {showCallButton && (
              <a 
                href="tel:+917389205299" 
                className="btn bg-secondary-500 text-gray-800 hover:bg-secondary-600 font-semibold flex items-center justify-center"
              >
                <Phone size={18} className="mr-2" />
                Call Now
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;